import React from "react";
import { useNavigate } from "react-router-dom";

import useEvacuationManger from "../../../../hooks/useEvacuationManager";

import CommonButton from "../../../../components/Button";

type Props = {};

export default function ExpiredSituation({}: Props) {
  const navigate = useNavigate();
  const [isManger, isUser] = useEvacuationManger();

  return (
    <div
      className="w-screen h-screen flex items-center justify-center"
      data-testid="expired-situation-wrapper"
    >
      <div className="flex flex-col items-center gap-16">
        <div className="text-2xl leading-[29.05px] font-extrabold">
          상황 만료
        </div>
        <div className="text-base leading-[15px] whitespace-pre-line text-center">
          {
            "이미 완료된 비상대피 상황 경로입니다.\n비상대피 진행중인 비회원이시라면,\n최근에 전달받은 알림톡 링크로 접근해주세요.\n감사합니다."
          }
        </div>
      </div>
      {isUser && (
        <div className="bg-white fixed bottom-0 w-full flex">
          <CommonButton
            variant="primary"
            className="flex-1 rounded-none text-base px-4 py-3 h-bottom-button"
            onClick={async () => {
              navigate("/");
            }}
          >
            닫기
          </CommonButton>
        </div>
      )}
    </div>
  );
}
